export const RX_STATUS_OPTIONS = [
  { value: 'PT. TO SUPPLY', viewValue: 'PT. TO SUPPLY' },
  { value: 'CALL FOR RX', viewValue: 'CALL FOR RX' },
] as const;

export type RxStatus = (typeof RX_STATUS_OPTIONS)[number]['value'] | '';
